import { render } from "./ChoiceCard.vue?vue&type=template&id=66effee2"
import script from "./ChoiceCard.vue?vue&type=script&lang=js"
export * from "./ChoiceCard.vue?vue&type=script&lang=js"

import "./ChoiceCard.vue?vue&type=style&index=0&id=66effee2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__